import { render, staticRenderFns } from "./PackagePricing.vue?vue&type=template&id=404e6906&scoped=true&"
import script from "./PackagePricing.vue?vue&type=script&lang=js&"
export * from "./PackagePricing.vue?vue&type=script&lang=js&"
import style0 from "./PackagePricing.vue?vue&type=style&index=0&id=404e6906&lang=scss&scoped=true&"
import style1 from "./PackagePricing.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e6906",
  null
  
)

export default component.exports